export default defineNuxtRouteMiddleware((to) => {
  if (process.client) {
    const { setLastVisitedPage, hasCurrentReport } = useCurrentReport()

    const reportPages = [
      '/location/',
      '/cause-of-damage/',
      '/measurement-protocol/',
      '/damage-mitigation/',
      '/damage-report/',
      '/present-persons/',
      '/additional-services/',
      '/recommended-actions/',
      '/exterior-view/',
      '/service-setup/',
      '/declaration-of-assignment/',
      '/annotations/'
    ]

    const isReportPage = reportPages.some((page) => to.path.startsWith(page))

    if (isReportPage && hasCurrentReport()) {
      setLastVisitedPage(to.fullPath)
    }
  }
})
